import burger from '../../assets/images/burger.jpg';
import pho from '../../assets/images/pho.jpg';
import tacos from '../../assets/images/tacos.jpg';

export default {
  name: 'Jumbotron',
  data() {
    return {
      burger,
      pho,
      tacos,
    };
  },
};
